import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalPerformanceFailed {
  modalIsOpen: boolean;
  toggleModal: () => void;
  tryAgain: () => void;
  performance?: number;
  minimumScore?: number;
}

export function ModalPerformanceFailed({
  modalIsOpen,
  toggleModal,
  tryAgain,
  performance,
  minimumScore,
}: IModalPerformanceFailed) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerDanger}`}>
        <i className="material-icons-outlined">sentiment_dissatisfied</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.title}>
          <span className={styles.highlightText}>OPS!</span> Quase lá...
        </h2>
        <p className={styles.detail}>
          Você performou{' '}
          <span className={styles.highlightText}>{performance}%</span>
          {typeof minimumScore === 'number' ? (
            <>
              , mas a performance mínima exigida é{' '}
              <strong>{minimumScore}%</strong>.
            </>
          ) : (
            ' neste quiz.'
          )}
        </p>
        <p className={styles.caption}>
          Tente novamente para melhorar seu resultado.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            tryAgain();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Tente novamente
        </button>
      </div>
    </Modal>
  );
}
